import { Component, h } from "preact";
import { route } from "preact-router";
import { Subscription } from "rxjs";

import { Transaction, TransactionVerify, PaymentIntent } from "../models";
import { makeSureTransactionWasVerified, Shared } from "../utils";
import { Config } from "../app.configs";
import { CybersourceUbaService } from "../services/cybersource-uba.service";
import { TranasctionErrorComponent } from "./shared/transaction-error.component";
import LoaderComponent from "./loader.component";

declare const VAS: any;

interface State {
    transaction?: Transaction;
    loading: boolean;
    error?: string;
    error_code?: string;
}

export default class CybersourceUbaComponent extends Component<any, State> {
    state: State = {
        loading: true,
        error_code: null
    };

    cybersourceUbaService = new CybersourceUbaService();

    token: string;
    intent: PaymentIntent;
    verifyTransaction: TransactionVerify;
    subscription: Subscription;

    checkoutClient: any;
    checkout: any;

    componentDidMount() {
        this.subscription = makeSureTransactionWasVerified(verifyTrans => {
            this.token = Shared.token;
            Shared.paymentMode.next("cybersource_uba");
            this.verifyTransaction = verifyTrans;

            this.setState({ transaction: verifyTrans.transaction });

            this.initCheckout();
        });
    }

    componentWillUnmount() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }

        this.destroyCheckout();
    }

    loadScript(): Promise<void> {
        if ((window as any).VAS) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = Config.cybersource_uba_script_url;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () =>
                reject(new Error("Impossible de charger le module de paiement."));
            document.body.appendChild(script);
        });
    }

    initCheckout() {
        this.setState({ loading: true, error: null, error_code: null });

        this.cybersourceUbaService
            .createPayment(this.token, {})
            .then(({ intent, capture_context }) => {
                Shared.intent = intent;
                this.intent = intent;

                if (intent.status !== "pending" || !capture_context) {
                    this.setState({
                        error: "Transaction échouée. Veuillez reessayer",
                        error_code: intent.last_error_code,
                        loading: false
                    });
                    return;
                }

                return this.loadScript().then(() =>
                    this.mountCheckout(capture_context)
                );
            })
            .catch(({ message }) => {
                this.setState({ error: message, error_code: null, loading: false });
            });
    }

    mountCheckout(captureContext: string) {
        return VAS.UnifiedCheckout(captureContext)
            .then((client: any) => {
                this.checkoutClient = client;

                return client.createCheckout({ autoProcessing: true });
            })
            .then((checkout: any) => {
                this.checkout = checkout;

                this.setState({ loading: false });

                return checkout.mount({
                    paymentSelection: "#uba-payment-buttons",
                    paymentScreen: "#uba-payment-form"
                });
            })
            .then((transientToken: string) =>
                this.handleCheckoutResult(transientToken)
            )
            .catch((error: any) => {
                if (error && error.name === "UnifiedCheckoutError") {
                    this.setState({
                        error: error.message,
                        error_code: error.reason,
                        loading: false
                    });
                } else {
                    this.setState({
                        error: "Transaction échouée. Veuillez reessayer",
                        error_code: null,
                        loading: false
                    });
                }
            });
    }

    handleCheckoutResult(transientToken: string) {
        this.setState({ loading: true });

        this.cybersourceUbaService
            .verify(this.token, this.intent.reference, transientToken)
            .then((intent: PaymentIntent) => {
                Shared.intent = intent;

                if (intent.status === "approved") {
                    route("/status/success", true);
                } else {
                    this.setState({
                        error: "Transaction échouée. Veuillez reessayer",
                        error_code: intent.last_error_code,
                        loading: false
                    });
                }
            })
            .catch(({ message }) => {
                this.setState({ error: message, error_code: null, loading: false });
            });
    }

    destroyCheckout() {
        if (this.checkout) {
            this.checkout.destroy();
            this.checkout = null;
        }

        if (this.checkoutClient) {
            this.checkoutClient.destroy();
            this.checkoutClient = null;
        }
    }

    render() {
        return (
            <div class="payment-container d-flex flex-column h-100 w-100">
                <div class="modal-body mb-auto">
                    <TranasctionErrorComponent
                        error={this.state.error}
                        error_code={this.state.error_code}
                    />

                    { this.state.loading && <LoaderComponent state='loading' /> }

                    <div id="uba-payment-buttons"></div>
                    <div id="uba-payment-form"></div>
                </div>
            </div>
        );
    }
}
